import React from "react";
import { ENV_ELECTRONIC_ID_URL } from "../../../../../../config/envVars";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import { devConsoleLog } from "../../../../../../utils/devConsoleLog";
import { ConfigContext } from "../../../../../../contexts/ConfigContext";
import { WIDGET_LOADING_TIMEOUT } from "../config";
import { documentTypes } from "../../../shared/config";

export const useElectronicId = ({
  selectedDocumentType,
  onSuccess,
  onError,
}) => {
  const {
    state: { kycAuthorization, videoId },
    dispatch,
  } = React.useContext(ProcessContext);

  const {
    state: { language },
  } = React.useContext(ConfigContext);

  const selectedDocument = documentTypes.find(
    (document) => document.display === selectedDocumentType
  );

  const [state, setState] = React.useState({
    loading: true,
    error: false,
    electronicID: window.EID,
    success: false,
  });

  const getEIDScriptElement = () =>
    Array.from(document.body.getElementsByTagName("script")).find(
      (script) => script.src === ENV_ELECTRONIC_ID_URL
    );

  const loadedEIDScriptElement = getEIDScriptElement();

  const { electronicID, loading } = state;

  React.useEffect(() => {
    dispatch({
      type: "GET_KYC_AUTH",
    });
  }, []);

  React.useEffect(() => {
    if (kycAuthorization && !electronicID && !loadedEIDScriptElement)
      loadLibrary();
  }, [kycAuthorization]);

  React.useEffect(() => {
    if (kycAuthorization && loadedEIDScriptElement && electronicID) {
      const newVideoId = electronicID.videoId("#video", { lang: language });
      dispatch({
        type: "UPDATE_PROCESS_CONTEXT",
        payload: { videoId: newVideoId },
      });
      initializeVideoId(newVideoId, kycAuthorization, selectedDocument.value);
    }
  }, [electronicID, kycAuthorization]);

  React.useEffect(() => {
    if (videoId) {
      setTimeout(() => {
        setState((s) => ({ ...s, loading: false }));
      }, WIDGET_LOADING_TIMEOUT);
    }
  }, [videoId]);

  const loadLibrary = () => {
    if (electronicID) return;
    const script = document.createElement("script");
    script.src = ENV_ELECTRONIC_ID_URL;
    script.type = "text/javascript";
    script.async = true;
    script.addEventListener("load", () => {
      setState((s) => ({ ...s, electronicID: window.EID }));
    });
    document.body.appendChild(script);
  };

  const initializeVideoId = (videoId, auth, selectedDocument) => {
    videoId.start({
      authorization: auth,
      idType: selectedDocument,
    });
    videoId.on("completed", function (video) {
      onSuccess(video);
    });
    videoId.on("failed", function (error) {
      onError(videoId, error);
    });
  };

  devConsoleLog("SELECTED DOCUMENT TYPE", selectedDocumentType);

  return { electronicID, loading };
};
